module.exports = __webpack_public_path__ + "img/index_rule.87c64901.png";